var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1946)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916ZM3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15863 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM8.81831 14.4432C8.81831 13.6529 9.55286 12.9091 10.3059 12.9091H23.6943C24.4474 12.9091 25.1819 13.6529 25.1819 14.3967V27.7851C25.1819 28.5382 24.4381 29.2727 23.6943 29.2727H10.3059C9.56212 29.2727 8.81831 28.5382 8.81831 27.7851V14.4432ZM10.3059 13.6529C9.93402 13.6529 9.56212 14.0248 9.56212 14.3967V27.7851C9.56212 28.157 9.93402 28.5289 10.3059 28.5289H23.6943C24.0662 28.5289 24.4381 28.157 24.4381 27.7851V14.3967C24.4381 14.0248 24.0662 13.6529 23.6943 13.6529H10.3059ZM23.6943 15.1405V25.5537L19.2315 21.0909L17.7439 22.5785L15.5125 19.6033L10.3059 25.5537V15.1405C10.3059 14.7686 10.6778 14.3967 11.0497 14.3967H22.9505C23.3224 14.3967 23.6943 14.7686 23.6943 15.1405ZM20.5797 18.5341C21.4269 18.5341 22.1138 17.8472 22.1138 17C22.1138 16.1527 21.4269 15.4659 20.5797 15.4659C19.7324 15.4659 19.0456 16.1527 19.0456 17C19.0456 17.8472 19.7324 18.5341 20.5797 18.5341Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageReport);
export default __webpack_public_path__ + "static/media/ImageReport.a4691ed42c038b0cb9e1a6b07eaa43fe.svg";
export { ForwardRef as ReactComponent };